import { message } from "antd";
import axiosInstance from "../shared/axios";

// get all roles
const getAllRoles = async (params) => {
  try {
    const result = await axiosInstance.get("/role/viewAll", {
      params: {
        name: params?.name || "",
        pageNo: params?.pageNo,
        recordsPerPage: params?.recordsPerPage,
      },
    });
    if (result?.status === 200 && result?.data?.success) {
      return {
        data: result?.data?.data || [],
        total: result?.data?.totalRecords || 0,
      };
    } else {
      message.error("Error while loading roles");
      return { data: [], total: 0 };
    }
  } catch (error) {
    message.error(
      error?.response?.data?.message || "Error while loading roles",
    );
    return { data: [], total: 0 };
  }
};

// get all permissions
const getAllViewRoles = async (params) => {
  try {
    const result = await axiosInstance.get("/module/viewModules");
    if (result?.status === 200 && result?.data?.success) {
      return {
        data: result?.data?.data || [],
      };
    } else {
      message.error("Error while loading roles lookups");
      return { data: [], total: 0 };
    }
  } catch (error) {
    message.error(
      error?.response?.data?.message || "Error while loading roles lookups",
    );
    return { data: [], total: 0 };
  }
};

const addEditRoles = async (payload, id) => {
  try {
    const result = await axiosInstance.post(
      id ? "/permissions/updateRole" : "/permissions/assignPermissions",
      { ...payload, id: id || null },
    );

    // Accept any 2xx status
    if (result?.data?.success === true) {
      return { success: true, data: result.data };
    } else {
      return { success: false, message: result?.data?.message };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to save role",
    };
  }
};

const getSingleRolePermission = async (id) => {
  try {
    let result = await axiosInstance?.get(`/permissions/getPermission/${id}`);
    if (result?.status === 200 && result?.data?.success) {
      return result?.data?.data;
    } else {
      message.error(
        "error",
        "Error while loading single role and permission detail",
      );
      return null;
    }
  } catch (error) {
    message.error("error", "Error while loading role and permission detail");
    return null;
  }
};

const deleteRole = async (id) => {
  try {
    const result = await axiosInstance.delete(`/role/delete/${id}`);

    if (result?.data?.success === true) {
      return { success: true };
    } else {
      return {
        success: false,
        message: result?.data?.message,
      };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete role",
    };
  }
};

const getRoleLookup = async () => {
  try {
    let result = await axiosInstance.get("/role/options");
    if (result?.status === 200 && result?.data?.success) {
      return result?.data?.data;
    } else {
      message.error("Error while loading roles");
      return null;
    }
  } catch (error) {
    message.error(
      error?.response?.data?.message || "Error while loading roles",
    );
    return null;
  }
};

export const rolepermissions = {
  getAllRoles,
  getAllViewRoles,
  addEditRoles,
  getSingleRolePermission,
  deleteRole,
  getRoleLookup,
};
